import { Component, HostListener, forwardRef, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, COMPILER_OPTIONS, ElementRef, OnInit, ViewChildren, QueryList, NgZone, Injector, OnDestroy } from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormControl } from "@angular/forms";
import { ListItem, IDropdownSettings } from "./multiselect.model";
import { BaseService } from '../../shared/services/base.service';
import { ActivatedRoute } from '@angular/router';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { LoaderService } from '../../services/loader.service';
import { of, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FormService } from '../form/form.service';
import { DialogService } from '../dialog/dialog.service';
import { DialogModalSize } from '../dialog/dialog-ref';
import { AdvanceSearchComponent } from '../advance-search/advance-search.component';
import { CommonService } from '../../services/common.service';
import { AlertsService } from "../../services/alerts.service";
import { TranslateService } from "../../services/translate.service";
import { IcdSearchComponent } from "src/modules/base/components/icd-search/icd-search.component";
import { RolePermissionService } from "../../shared/services/role-permission.service";
import { PreferenceService } from "../../shared/services/preference.service";
import { TextToSpeechComponent } from "../text-to-speech/text-to-speech.component";
import { UtilService } from 'src/modules/base/services/util.service';
import * as CryptoJS from "crypto-js";
import { Icd11Component } from "../icd-11/icd-11.component";

export const DROPDOWN_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MultiSelectComponent),
  multi: true
};
const noop = () => { };
declare var jQuery: any;
@Component({
    selector: "kx-multiselect-dropdown",
    templateUrl: "./multi-select.component.html",
    styleUrls: ["./multi-select.component.scss"],
    providers: [DROPDOWN_CONTROL_VALUE_ACCESSOR],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MultiSelectComponent implements ControlValueAccessor, OnInit,OnDestroy {
  private sub: Subscription = new Subscription();
  private boundEnterHit: (event: any) => void;
  @Input() custom: boolean;
  setPre: boolean = true;
  greaterHeight: boolean = false;
  cacheObj:any;
  customDataNotFoundMessage:'';
  transaltedCustomDataNotFoundMessage:any;
  ngOnInit(): void {
    this.sub.add(this.translateService.translate("field.label.search").subscribe(tran_text => {
      if (tran_text) {
        this._settings.searchPlaceholderText = tran_text;
      }
    }));
    if(this?.questions?.defaultsetting?.customDataNotFoundMessage)
    {
       this.customDataNotFoundMessage=this.questions.defaultsetting.customDataNotFoundMessage
       if(this.customDataNotFoundMessage)
       {
        this.getTranslatedCustom404Message()
       }
    }
    
  }
  getTranslatedCustom404Message()
  {
    this.sub.add(this.translateService.translate(this.customDataNotFoundMessage).subscribe(x => {
      if (x) {
          this.transaltedCustomDataNotFoundMessage = x;
      }
  }));
  }
  ngAfterViewInit(): void {
    if (!(this._value && this._value.length)) {
      this.writeValue(null);
    }
    if (this._settings && this._settings.onEnterSearch) {
      this.ngZone.runOutsideAngular((event) => {
        //window.addEventListener('keyup', this.getDataOnEnterButtonHit);
        this.boundEnterHit = this.getDataOnEnterButtonHit;  // already arrow fn, no bind needed
        window.addEventListener('keyup', this.boundEnterHit);
      });
    }
    this.initComplexSearch();
  }

  initComplexSearch() {
    if (this.questions && this.questions.complexSearch && Array.isArray(this.questions.complexSearch) && this.questions.complexSearch.length > 0) {
      this.complexSearchFields = this.questions.complexSearch;
      this.selectedSearchField = this.complexSearchFields[0];
      const prefKey = this.getComplexSearchPrefKey();
      if (prefKey) {
        this.prefereceService.getUserPreferenceConfig(prefKey, (savedData) => {
          if (savedData && savedData.key) {
            const matched = this.complexSearchFields.find(f => f.key === savedData.key);
            if (matched) {
              this.selectedSearchField = matched;
              this.complexSearchColumnChosen = true;
              this.applyComplexSearchColumn();
              if (!this.cdr['destroyed']) {
                this.cdr.detectChanges();
              }
            }
          }
        });
      }
    }
  }

  // re-applied in `set data` too: a change_value dependent swaps in a new datasource object and would drop the chosen column
  applyComplexSearchColumn() {
    if (this.complexSearchColumnChosen && this.selectedSearchField && this.apliCallingRqrPrm && typeof this.apliCallingRqrPrm == 'object') {
      this.apliCallingRqrPrm['search_columns'] = this.selectedSearchField.key;
      this.apliCallingRqrPrm['searchColumns'] = this.selectedSearchField.key;
    }
  }

  getComplexSearchPrefKey(): string {
    if (this.questions && this.questions.key) {
      return 'ss_complex_search_' + this.questions.key;
    }
    return null;
  }

  saveComplexSearchPreference(field: any) {
    const prefKey = this.getComplexSearchPrefKey();
    if (prefKey && field) {
      this.prefereceService.saveTableConfigData(prefKey, { key: field.key, label: field.label });
    }
  }

  onComplexSearchFieldSelected(field: any, event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.showComplexSearchPopup = false;
    if (field) {
      this.selectedSearchField = field;
      this.complexSearchColumnChosen = true;
      this.applyComplexSearchColumn();
      this.saveComplexSearchPreference(field);
    }
    if (this.dataFromApiModel && this.dataFromApiModel.trim() !== '') {
      this.getDataBasedOnModel(this.dataFromApiModel, false);
    }
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

  toggleComplexSearchPopup(event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    if (this.complexSearchFields.length > 1) {
      this.showComplexSearchPopup = !this.showComplexSearchPopup;
    }
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

  hasComplexSearch(): boolean {
    return this.complexSearchFields && this.complexSearchFields.length > 0;
  }
  
  getDataOnEnterButtonHit = (event) => { // this function will call API in searchSelect after enter button
    this.ngZone.run(() => {
      let x = document.activeElement.tagName;
      if (x && x != "INPUT") {
        return false;
      }
      if (event.code == "Enter" && event.keyCode == 13) { // when Enter key will be presssed
        console.log(`${this.dataFromApiModel} to be passed as search in api`)
        this.getDataBasedOnModel(this.dataFromApiModel, false);
      }
    })
  }
  public _settings: IDropdownSettings;
  public _data: Array<ListItem> = [];
  public selectedItems: Array<ListItem> = [];

  public dataBasedModelChanged: Subject<string> = new Subject<string>();
  public filterBasedModelChanged: Subject<string> = new Subject<string>();
  public isLoading = false;
  public focusedIdx: number = -1;
  public focusedStatus: boolean = false;
  public isDropdownOpen = true;
  _placeholder = "Select"; //speechKey = "speech"; // default speech key for multiselect search, can be override by passing from question default setting
  private _sourceDataType = null; // to keep note of the source data type. could be array of string/number/object
  private _sourceDataFields: Array<String> = []; // store source data fields names
  private _defaultValue: any = false; // store source data fields names
  filter: ListItem = new ListItem(this.data);
  defaultPageSize = 20; // number of data to be populated defaultly
  ShowFilter = false; dynamic_id: any;
  showAll = false;
  dataFromApiModel = "";
  apliCallingRqrPrm: object;
  resetTimer: any; // pending deferred reset, cancelled when a value arrives before it runs
  icd_enable = true;
  complexSearchFields: any[] = [];
  selectedSearchField: any = null;
  complexSearchColumnChosen: boolean = false;
  showComplexSearchPopup = false;
  showMoreObj: any = {
    currentPage: 0,
    limit: null,
    hasMoreData: true,
    isLoadingMore: false,
    finalParam: null,
    noMoreData: false
  };

  @Output() optionsLoaded = new EventEmitter<Array<ListItem>>();
  defaultSettings: IDropdownSettings = {
    configFreeText: false,
    freeText: false,
    free_text_with_data: false,
    markFreeText: false,
    spclChrFreeTextAllowed: false,
    singleSelection: false,
    allowSearchFilter: true,
    clearSearchFilter: true,
    closeDropDownOnSelection: false,
    showSelectedItemsAtTop: false,
    defaultOpen: false,
    enableCheckAll: false,
    idField: "id",
    spclChrPattern: '',
    textField: "text",
    disabledField: "isDisabled",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    limitSelection: -1,
    maxHeight: 197,
    itemsShowLimit: 2,
    searchPlaceholderText: "Search....",
    noDataAvailablePlaceholderText: "Type to Search...",
    checkBoxRequired: false,
    displayName: "",
    itemCode: "",
    barcode: false,
    flag: false,
    createComponent: false,
    hasAppliedCss: false,
    location_icon: "",
    createComponentDatasource: {},
    isMinHeight: true,
    speechToText: true,
    defaultData: true, //setting to populate default data
    advancesearch: true,
    onEnterSearch: false,
    stopInitialization: false,
    hit_search: false,
    textSearch: false,
    custom: false,
    coding_system: "",
    filter:[]
  };
  @Input()
  public set placeholder(value: string) {
    if (value) {
      this._placeholder = value;
    } else {
      this._placeholder = "field.label.select";
    }
  }
  public injector: Injector;
  @Input() loaderVal = true;
  @Input() disabled = false;
  @Input('value') _value: any = [];
  @Input() setId: string;
  @Input() questions: any;
  @Input() controlName: any;
  @Input() format: any;
  @Input() config: any = {};
  @Input()
  public set settings(value: IDropdownSettings) {
    //console.log("Settings is", value);
    if (value) {
      this._settings = Object.assign(this.defaultSettings, value);
    } else {
      this._settings = Object.assign(this.defaultSettings);
    }
    if (this._settings.freeText && !this.defaultSettings.configFreeText) {
      this.getConfigForFreeText();
    }
  }
  public commonConfig: any = {};
  @ViewChildren("availableOption") public availableOptions: QueryList<
    ElementRef
  >;

  ngDoCheck() {
    
  }
  @Input()      ///////   if you want ot get data as input param code goes here
  public set data(value: any) {
    this.focusedIdx = -1;
    this.apliCallingRqrPrm = value;
    this.applyComplexSearchColumn();
    if (this._settings && this._settings['apliCall'] && this._settings['custom'] && !this.setDefaultValue()) {
      if (value && typeof value == 'object' && (value.resource != undefined || value.possible_value != undefined)) {
        this.bindData(value);
      } else {
        this.noDataFound();
      }
    } else if (this._settings && this._settings['apliCall']) {
      //this.noDataFound();
      //this.getDataBasedOnModel("")
      this.setDefaultValue();
    } else {
      //don't fire the api in case of update and set the selected items manually.
      if (!this.setDefaultValue()) {
        if (value && typeof value == 'object' && (value.resource != undefined || value.possible_value != undefined)) {
          this.bindData(value);
        } else {
          this.noDataFound();
        }
      }
    }
  }

  noDataFound() {
    this._data = [
      {
        id: "0",
        isDisabled: true,
        mixdata: '',
        formatText: "",
        text: this.defaultSettings.noDataAvailablePlaceholderText
      }
    ];
  }
  setDefaultValueForViewKey() {
    //barcode
    var item = new ListItem({
      id: this.controlName.controls[this.setId].value, //item.id ? item.id : "",
      text: this.controlName.controls[this.questions.view_key].value,
      mixdata: this.controlName.value ? this.controlName.value : {},
      isDisabled: false,
    });
    
    console.log("itemitemitemitemitemitemitemitem", item);
    if (this.questions && this.questions.defaultsetting && this.questions.defaultsetting._sourceDataType)
      this._sourceDataType = this.questions.defaultsetting._sourceDataType;
    this.setSelectedItem(item);
  }
  setDefaultValue() {
    if (this._settings != undefined && this._settings.defaultData) { // to populate default data
      if (this.controlName != undefined && this.controlName.controls != undefined && this.questions != undefined && this.questions.key != undefined) {
        if (this.controlName.controls[this.questions.key] != undefined && this.controlName.controls[this.questions.key].value != undefined) {
          let selectedValue = this.controlName.controls[this.questions.key].value
          if (!Array.isArray(selectedValue)) {
            if (!this._settings.stopInitialization) {
              if(this?.questions?.defaultsetting?.allowAPICallOnModify && (this?.controlName?.controls?.[this?.questions?.key]?.value == this._value)) {
                  this.getDataBasedOnModel(undefined);
              } else {
                this.getDataBasedOnModel(this.controlName.controls[this.questions.key].value) // api call for single selected value
              }
            }
            if (selectedValue != "") {
              this._defaultValue = selectedValue;
            }
          } else {
            // .... multiselect flow
            // this._data = selectedValue.map((item: any) =>
            //   typeof item === "string" || typeof item === "number"
            //     ? new ListItem(item)
            //     : new ListItem({
            //       id: item.id ? item.id : "",
            //       text: item.text ? item.text : "",
            //       mixdata: item,
            //       isDisabled: false,
            //   })
            // );
            // commented due to format issues for multiselect
          }
        }
      }
    }
    if (this.questions != undefined && this.questions.view_key != undefined && this.questions.view_key && this.controlName && this.controlName.controls[this.questions.view_key] != undefined &&
      this.controlName.controls[this.setId] != undefined && this.controlName.controls[this.questions.view_key].value != "" &&
      this.controlName.controls[this.setId].value != "") {
      this._sourceDataType = 'object';
      if (this._settings.singleSelection) {
        this.selectedItems = [];
      }
      this.setDefaultValueForViewKey();
      //working for setting options as when we have view key and dependend is there so our dependent logic needs options as well
      if (this.questions.dependents != undefined && this.questions.dependents.length != undefined && this.questions.dependents.length) {
        if(this?.questions?.defaultsetting?.allowAPICallOnModify) {
          this.getDataBasedOnModel(undefined);
        } else {
          this.getDataBasedOnModel(this.controlName.controls[this.questions.view_key].value);
        }
      }
      return true;
    } else {
      return false;
    }
  }

  bindData(value: any, filter?) {
    // ******** Decorator Implemented ******** //
    if (this.config && this.config.decorator != undefined && this.config.decorator) {
        this.config.decorator = this.baseService.initDecorator(this.config.decorator, this.route, this.injector);
    }
    // ******** Decorator Implemented ******** //

    // debugger
    if (value) {
      if (value.hasOwnProperty('possible_value')) { // Returning data in case of possible_values
        this._sourceDataType = 'object';
        this._data = value.possible_value;
        this.parseMyObject(value.possible_value)
        return
      } else if (value.length > 0) {
        this.parseMyObject(value);
      }
      else {
        //-------------valueset cacheing mechanism start--------------------------//  
        if (value && value.query_id && value.query_id == 'get_valueset_by_id_flat') {
          value.cachable = true;  // set cachable true always for valueset query
        }
        //-------------valueset cacheing mechanism end--------------------------//  

        let cacheParam = this.createCacheParam(value);
        let key = CryptoJS.MD5(cacheParam).toString();
        if (value && value.cachable && key && this.baseService.getCachedData(key)) {
          let data = this.baseService.getCachedData(key);
          this.parseMyObject(data);
        } else {
          var data = this.setparentForm();
          var makeArgs = {
            args: value['args'] != undefined ? this.baseService.buildDyanamicStr(value["args"], { data: data }) : "",
            filter: value['filter'] != undefined ? this.baseService.buildDyanamicStr(value["filter"], { data: data }) : "",
            projectionKeys: (this.questions != undefined && ((this.questions['req_keys'] && this.questions['req_keys'] != 'all') || this.questions['req_keys'] == undefined)) ? this.baseService.getProjectionKeys([this.questions['getterKey'], this.questions['getterValue']], this.questions['req_keys'], 'dropdown') : ''
          }
          makeArgs.args = this.baseService.checkargs(makeArgs.args);
          makeArgs.filter = this.baseService.checkargs(makeArgs.filter);
          if(filter){
            makeArgs.filter += filter;
          }
          if(!value['readPreference']){
                makeArgs['readPreference'] = 'secondaryPreferred';
          }

          this.setNoCountArgs(makeArgs);
         
          // if (value != undefined && value.query_id == "GET_ALL") {
          //   makeArgs['page_no'] = 0;
          //   makeArgs['page_size'] = 20;
          //   value.query_id = "GET_PAGE";
          // }
          if(this.loaderVal)
            this.loader.showSpinner();
          this.showMoreObj.finalParam = JSON.parse(JSON.stringify(makeArgs));
          this.sub.add(this.baseService.getData(makeArgs, "", value.resource, value.application, value.query_id).subscribe(
            (res) => {
              //console.log("data is as per multidropdown::", res, value);
              if (res.resource) {
                this.setDefaultValueFromSetting(res);
                if (value.hasOwnProperty('composite') && res.resource.length != 0) {
                  this.parseMyObject(res.resource[0][value.composite]);
                }
                else if (value && value.cachable && this.cacheObj == undefined) {
                  this.cacheObj = value['page_no'] + value['page_size'] + value['searchColumns'] + value['search_columns'] + value.args + value.filter + value.search + value.projectionKeys + this.apliCallingRqrPrm['resource'] + this.apliCallingRqrPrm['application'] + (this.apliCallingRqrPrm['queryId']?this.apliCallingRqrPrm['queryId']:this.apliCallingRqrPrm['query_id']);
                  this.parseMyObject(res.resource, this.cacheObj);
                }
                else {
                  this.parseMyObject(res.resource);
                }
              } else {
                this.noDataFound();
                if (res.errCode != 0)
                  this.alerts.error(res.message)
              }
              if(this.loaderVal)
                this.loader.hideSpinner();
            }, (err) => {
              this.noDataFound();
              this.loader.hideSpinner();
            }
          ));
        }
      }
    }
  }
  parseMyObject = (value: Array<any>, cachable?) => {
    if (!value) {
      this.questions['options'] = [];
      this._data = [];
      this.formService.setOpionChanged(this.questions);
    } else {
      this.questions['options'] = value;
      this.formService.setOpionChanged(this.questions);
      // this._data = []//re init the options
      const firstItem = value[0];
      if (!this.defaultSettings.singleSelection && this.defaultSettings.freeText) {
        this._sourceDataType = 'object';
      } else {
        this._sourceDataType = typeof firstItem;
      }


      this._sourceDataFields = this.getFields(firstItem);
      const mappedData = value.map((item: any) =>
        typeof item === "string" || typeof item === "number"
          ? new ListItem(item)
          : new ListItem({
            id: item[this.questions['getterKey']], //item.id ? item.id : "",
            text: item[this.questions['getterValue']],
            mixdata: item,
            isDisabled: item[this.questions['status']] ? item[this.questions['status']] : false,
          })
      );

      //append logic
      if (this.showMoreObj.currentPage === 0) {
        this._data = mappedData; // first load
      } else {
        this._data = [...this._data, ...mappedData]; // show more
      }

      this.showMoreObj.limit = this?.apliCallingRqrPrm?.hasOwnProperty?.('page_size') ? this?.apliCallingRqrPrm?.['page_size'] : this?.defaultPageSize;
      
      //control "Show More" (check length of value beacause it has response of current api call/ check aplicall false because in that case pagination not applied)
      if ((this._settings && !this._settings['apliCall']) || value.length == 0 || value.length < this.showMoreObj.limit || value.length > this.showMoreObj.limit) {
        this.showMoreObj.hasMoreData = false;
      } else if (value.length === this.showMoreObj.limit) {
        this.showMoreObj.hasMoreData = true;
      }

      this.optionsLoaded.emit(this.questions);
      if (cachable) {
        let key = CryptoJS.MD5(cachable.toString()).toString();
        this.baseService.setCachedData(key, value);
      }
      if (!this.cdr['destroyed']) {
        this.cdr.detectChanges();
      }
    }
    //in case of update when single selection : find out the selected item from api response.
    if (this._settings.singleSelection && this._data && this._data.length) {
      if (this._defaultValue == "") {
        // this.resetInput();
      } else {
        for (let item of this._data) {
          if (item.mixdata != undefined && item.mixdata[this.questions.getterKey] != undefined && item.mixdata[this.questions.getterKey] == this._defaultValue) {
            this.selectedItems = [];
            this.setSelectedItem(item);
            if (this._settings.createComponent && this._settings.createComponentDatasource && this._value != '') {
              this.createComponentEvent.emit({
                getterKey: item[this.questions.getterKey],
                data: item.mixdata,
                datasource: this._settings.createComponentDatasource,
                perserveTemplate: this._settings.preserveTemplate,
                keys_to_remove: this.questions.keys_to_remove,
                set_template_block: this.questions.set_template_block
              })
            }
            break;
          }
        }
      }

    }
    return this._data;
  }

  loadMoreData() {
    if (this?.showMoreObj?.noMoreData || !this?.showMoreObj?.hasMoreData) return;

    this.showMoreObj.isLoadingMore = true;//for check data loading
    this.showMoreObj.currentPage++;
    this.showMoreObj.limit = this?.apliCallingRqrPrm?.hasOwnProperty?.('page_size') ? this?.apliCallingRqrPrm?.['page_size'] : this?.defaultPageSize;

    const params = {
      ...this?.showMoreObj?.finalParam,
      page_no: this?.showMoreObj?.currentPage,
      page_size: this?.showMoreObj?.limit
    };

    this.baseService.getData(params, "", this?.apliCallingRqrPrm?.['resource'], this?.apliCallingRqrPrm?.['application'], this?.apliCallingRqrPrm?.['query_id']).subscribe((res) => {
      this.showMoreObj.isLoadingMore = false;
      if (res?.errCode != 0) {
        this.showMoreObj.noMoreData = true;
        this.alerts.error("No More Data Exist");
      } else if (res?.resource?.length > 0) {
        this.parseMyObject(res.resource);
      }
      if (!this.cdr['destroyed']) this.cdr.detectChanges();
    }, () => {
      this.showMoreObj.noMoreData = true;
      this.showMoreObj.isLoadingMore = false;
      if (!this.cdr['destroyed']) this.cdr.detectChanges();
    }
    );
  }

  createCacheParam(param) {
    return param['page_no'] + param['page_size'] + param['searchColumns'] + param['search_columns'] + param.args + param.filter + param.search + param.projectionKeys + this.apliCallingRqrPrm['resource'] + this.apliCallingRqrPrm['application'] + (this.apliCallingRqrPrm['queryId']?this.apliCallingRqrPrm['queryId']:this.apliCallingRqrPrm['query_id']);
  }


  @Output("onFilterChange")
  onFilterChange: EventEmitter<ListItem> = new EventEmitter<any>();
  @Output("onDropDownClose")
  onDropDownClose: EventEmitter<ListItem> = new EventEmitter<any>();

  @Output("onSelect")
  onSelect: EventEmitter<ListItem> = new EventEmitter<any>();

  @Output("onDeSelect")
  onDeSelect: EventEmitter<any> = new EventEmitter<any>();

  @Output("onSelectAll")
  onSelectAll: EventEmitter<Array<ListItem>> = new EventEmitter<Array<any>>();

  @Output("onDeSelectAll")
  onDeSelectAll: EventEmitter<Array<ListItem>> = new EventEmitter<Array<any>>();

  @Output() createComponentEvent = new EventEmitter();
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;


  onFilterTextChange($event) {
    this.focusedIdx = -1;
    this.defaultSettings.hit_search = true;
    this.filterBasedModelChanged.next($event);
  }
  getValue(item, format) {
    try {
      let fn;
      if (format != undefined && item != undefined && eval(format)(item) != undefined) {
        var formatText = eval(format)(item);
        var seperator = '';
        if (formatText.includes("||")) { // Removed empty keys from string
          seperator = "||";
        }
        else if (formatText.includes(',')) {
          seperator = ",";
        }
        if (seperator && seperator != '') {
          var text = '';
          var formatArray = formatText.split(seperator);
          for (let i = 0; i < formatArray.length; i++) {
            if (formatArray[i].trim() != '') {
              text += formatArray[i] + seperator;
            }
          }
          formatText = text.substring(0, text.length - seperator.length);
        }
        item.formatText = formatText;
        return formatText;
      }
    } catch (e) {
      console.warn(e)
      return "";
    }

  }
  changeDataBasedModel($event: any) {
    console.log("event is ",$event);
    this.defaultSettings.hit_search = true;
    this.dataBasedModelChanged.next($event);
  }

  changeFilterSet(filter){
    this.bindData(this.apliCallingRqrPrm, filter);
  }

  getdataFromDb(params) {
    console.log("Final Param to search data ------", params);
    this.setNoCountArgs(params);
    this.showMoreObj.finalParam = JSON.parse(JSON.stringify(params));
    if (this.apliCallingRqrPrm['resource'] != undefined) {
      this.sub.add(this.baseService.getData(params, "", this.apliCallingRqrPrm['resource'], this.apliCallingRqrPrm['application'], this.apliCallingRqrPrm['query_id']).subscribe(
        (res) => {
          this._data = [];
          this.filter.text = "";
          if (res.resource) {
            if (this._settings['setApiCallDefault'] != undefined && this._settings['setApiCallDefault']) {
              this.setDefaultValueFromSetting(res);

            }
            this.parseMyObject(res.resource, this.cacheObj);
          }
          this.isLoading = false;
          if (res.errCode != 0)
            this.alerts.error(res.message)
          if (!this.cdr['destroyed']) {
            this.cdr.detectChanges(); //For detecting changes from form and reseting the value
          }
          this.loader.hideSpinner();
        }, (err) => {
          this.isLoading = false;
          if (!this.cdr['destroyed']) {
            this.cdr.detectChanges(); //For detecting changes from form and reseting the value
          }
          console.log("Error occured while getting data", err)
          this.loader.hideSpinner();
        }));
    } else{
      if(this.apliCallingRqrPrm['possible_value'] && Array.isArray(this.apliCallingRqrPrm['possible_value']) && this.apliCallingRqrPrm['possible_value'].length > 0){
        this.parseMyObject(this.apliCallingRqrPrm['possible_value']);
      }
      this.isLoading = false;
        if (!this.cdr['destroyed']) {
          this.cdr.detectChanges();
        }
      this.loader.hideSpinner();
    }
  }

  getDataBasedOnModel($event: any, hideloader: boolean = false) {
    this.showMoreObj.currentPage = 0;
    this.showMoreObj.hasMoreData = true;
    this.showMoreObj.noMoreData = false;
    if (this.questions != undefined && this.questions.defaultsetting && this.questions.defaultsetting.defaultOpen != undefined && this.questions.defaultsetting.defaultOpen) {
      this._settings.defaultOpen = true;
    }
    this.focusedIdx = -1;
    if ($event == undefined) {
      $event = '';
    }
    if (this._settings['apliCall']) {
      //debugger;
      this.isLoading = true;
      if (!this.cdr['destroyed']) {
        this.cdr.detectChanges(); //For detecting changes from form and reseting the value
      }
      if (this.apliCallingRqrPrm) {
        if (this.defaultSettings && this.defaultSettings['decorator'] != undefined && this.defaultSettings['decorator'] && this.formService?.popupForm?.value) {
          this.defaultSettings['decorator'] = this.baseService.initDecorator(this.defaultSettings['decorator'], this.route, this.injector);
          if (this.defaultSettings['decorator'] && this.defaultSettings['decorator'].setDataForApiCall) {
            this.defaultSettings['decorator'].setDataForApiCall(this.apliCallingRqrPrm, this.formService)
          }
        }
        var data = this.setparentForm();
        var params = {
          args: this.apliCallingRqrPrm.hasOwnProperty('args') ? this.baseService.buildDyanamicStr(this.apliCallingRqrPrm['args'], { data: data }) : '',
          filter: this.apliCallingRqrPrm.hasOwnProperty('filter') ? this.baseService.buildDyanamicStr(this.apliCallingRqrPrm['filter'], { data: data }) : '',
          search: $event ? $event : '',
          projectionKeys: (this.questions != undefined && ((this.questions['req_keys'] && this.questions['req_keys'] != 'all') || this.questions['req_keys'] == undefined)) ? this.baseService.getProjectionKeys([this.questions['getterKey'], this.questions['getterValue']], this.questions['req_keys'], 'dropdown') : ''
        }
        if(this.apliCallingRqrPrm.hasOwnProperty('readPreference'))
          params['readPreference'] = this.apliCallingRqrPrm['readPreference'];
        
        params.filter = this.baseService.checkargs(params.filter);
        if (this.apliCallingRqrPrm.hasOwnProperty('page_size') && this.apliCallingRqrPrm.hasOwnProperty('page_no')) {
          params['page_no'] = this.apliCallingRqrPrm['page_no'];
          params['page_size'] = this.apliCallingRqrPrm['page_size'];
        } else {
          params['page_no'] = 0;
          params['page_size'] = this.defaultPageSize;
        }

        if (this.apliCallingRqrPrm != undefined && this.apliCallingRqrPrm['search_columns'] != undefined) {
          params['search_columns'] = this.apliCallingRqrPrm['search_columns'];
          params['searchColumns'] = this.apliCallingRqrPrm['search_columns'];
        }
        if (this._settings.textSearch && this.rolePermission.checkIfEnabled('text_search') && this.prefereceService.checkCommonConfigEnabled('text_search')) {
          if(this.questions.origStopSorting == undefined){
            this.changeTextSearch(true);
          }
          params["args"] += ',text_search:true';
        }
        //PAGINATION
        ///PAGINATION ADDED 
        // if (params != undefined && this.apliCallingRqrPrm != undefined && this.apliCallingRqrPrm['query_id'] === "GET_ALL") {
        //   params['page_no'] = 0;
        //   params['page_size'] = 20;
        //   this.apliCallingRqrPrm['query_id'] = "GET_PAGE";
        // }
      }
      if (!hideloader) {
        this.loader.showSpinner();
      }
      //-------------valueset cacheing mechanism start--------------------------//  
      if (this.apliCallingRqrPrm && this.apliCallingRqrPrm['query_id'] && this.apliCallingRqrPrm['query_id'] == 'get_valueset_by_id_flat') {
        this.apliCallingRqrPrm['cachable'] = true;  // set cachable true always for valueset query
      }
      //-------------valueset cacheing mechanism end--------------------------//  

       //-------------dropdown cacheing mechanism start--------------------------//  
    if (this.apliCallingRqrPrm != undefined && this.apliCallingRqrPrm['cachable']) {
      try {
        this.cacheObj = this.createCacheParam(params);
        let key = CryptoJS.MD5(this.cacheObj).toString();
        if (this.baseService.getCachedData(key)) {
          //this._data = this.parseMyObject(this.baseService.getCachedData(key),this.cacheObj);
          this._data = [];
              this.filter.text = "";
              if (this.baseService.getCachedData(key)) {
                this.parseMyObject(this.baseService.getCachedData(key),this.cacheObj);
              }
              this.isLoading = false;
          this.loader.hideSpinner();
          if (!this.cdr['destroyed']) {
            this.cdr.detectChanges();
          }
        }else{
          this.getdataFromDb(params);
        }
      } catch (error) {
        console.error(error);
      }
    }
    //-------------dropdown cacheing mechanism end--------------------------//
    else{
      this.getdataFromDb(params);
    }
    } else {
      this.noDataFound();
      this.filter.text = "";
      this._settings.closeDropDownOnSelection = true;
      if (!this.cdr['destroyed']) {
        this.cdr.detectChanges(); //For detecting changes from form and reseting the value
      }
    }

  }

  constructor(
    public cdr: ChangeDetectorRef,
    public baseService: BaseService,
    public route: ActivatedRoute,
    public appService: AppService,
    public ele: ElementRef,
    public formService: FormService,
    public loader: LoaderService,
    public utilService: UtilService,
    public dialogService: DialogService,
    public ngZone: NgZone,
    public translateService: TranslateService,
    public rolePermission: RolePermissionService,
    public prefereceService: PreferenceService,
    public commonService?: CommonService,
    public alerts?: AlertsService
  ) {
    if (appService.getSessionId()) {
      var currentuser = appService.getCurrentUser();
      if (currentuser != undefined) {
        this.prefereceService.getCommonConfig((configData) => {
         // console.log("this.commonConfig", configData);
          this.commonConfig = configData;
          if (configData != undefined && configData['icd_enable'] != undefined)
            this.icd_enable = configData['icd_enable'];
        })
      }
    }

    this.sub.add(this.dataBasedModelChanged
      .pipe(
        debounceTime(1000),
        distinctUntilChanged()
      ). // wait 300ms after the last event before emitting last event
      subscribe((model: any) => {
        if (this._settings && !this._settings.onEnterSearch) {
          this.dataFromApiModel = model;
          this.getDataBasedOnModel(model, true);
        }
      }
      ));

    this.sub.add(this.filterBasedModelChanged
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      ). // wait 300ms after the last event before emitting last event
      subscribe((model: any) => {
        this.filter.text = model;
        this.onFilterChange.emit(model);
      }
      ));
  }

  setDefaultValueFromSetting(res) {
    if (this._settings['setDefaultVal'] != undefined && this._settings['setDefaultVal'] && this.config != undefined && this.config.form_action != undefined && (this.config.form_action == 'SEARCH' || this.config.form_action == 'ADD' || (this.config.form_action == 'MODIFY' && (this.config != undefined && this.config.parentForm != undefined && this.config.parentForm._manualChange != undefined && this.config.parentForm._manualChange)))) {
      try {
        let defaultVal = this.baseService.buildDyanamicStr(this._settings['setDefaultVal'], { data: {} });
        let key = "";
        if (this._settings['setDefaultValToCheck'] && this.questions != undefined && !this.questions.value) {
          key = this._settings['setDefaultValToCheck'];
        } else {
          key = this.questions.getterKey
        }
        let val;
        if (this._settings['setDefaultValToCheckExpression'] != undefined) {
           try {
            let fn;//not to be removed
            val = eval(this._settings['setDefaultValToCheckExpression'])();
            console.log("val is as follows::",val);
           } catch (error) {}
        }
        else {
          val = res.resource.find(x => x[key] === defaultVal);
        }
        if (val != undefined && val) {
          this._defaultValue = val[this.questions.getterKey];
        }
      } catch (error) { }
    }
  }

  onItemClick(item: ListItem, index, event?: any) {
    // ******** Decorator Implemented ******** //
    if (this.config && this.config.decorator != undefined && this.config.decorator && this.config.onItemClickedDecorator != undefined && this.config.onItemClickedDecorator) {
        // this.config.decorator = this.baseService.initDecorator(this.config.decorator, this.route, this.injector);
        this.config.decorator.onItemClickedDecorator(item, this._settings, index);
    }
    // ******** Decorator Implemented ******** //

    // console.log("On each item select", item);
    if ((this.disabled || item.isDisabled) && event) {
      event.preventDefault();
      return false;
    }

    if (this.config != undefined && this.config.stopPropagation != undefined) {
      this.config.stopPropagation = {};
    }
    const found = this.isSelected(item);
    console.log("Settings ", this._settings.limitSelection, this.selectedItems.length);
    const allowAdd = this._settings.limitSelection === -1 || (this._settings.limitSelection > 0 && this.selectedItems.length < this._settings.limitSelection) || (!this._settings.singleSelection && this._settings.enableCheckAll);
    if (!found) {
      if (allowAdd) {
        var secondApiCallingConditionTrue = this._settings['onSelectApliCallRequirement'] ? this._settings['onSelectApliCallRequirement'] : '';
        if (secondApiCallingConditionTrue != '' && secondApiCallingConditionTrue['onResponseFillControls']) {
          var secndApiReq = this._settings['onSelectApliCallRequirement']; // store in var

          //abhinav
          let filters = "";
          if (secndApiReq['filter'] != undefined && secndApiReq['filter'].includes(",")) {
            let multipleFilters = secndApiReq['filter'].split(",");
            for (let i = 0; i < multipleFilters.length; i++) {
              let filter = multipleFilters[i];
              if (item.mixdata[filter] != null) {
                filters += filter + ":" + item.mixdata[filter] + ","
              }
            }
            filters = filters.substring(0, filters.length - 1);
          }
          //till here
          else {
            filters = secndApiReq['filter'] + ":" + item.id;
          }

          let args = secndApiReq['args'] + ":" + item.id;
          // let args = secndApiReq['args'];
          var filterParams = { // get object ready to call data 
            filter: this.baseService.checkargs(filters),
            args: this.baseService.buildDyanamicStr(secndApiReq['default_args'] ? secndApiReq['default_args'] : '', { data: item.mixdata })
          };


          this.setNoCountArgs(filterParams);

          ///PAGINATION ADDED 
          // if (filterParams != undefined && secondApiCallingConditionTrue != undefined && secondApiCallingConditionTrue['query_id'] === "GET_ALL") {
          //   filterParams['page_no'] = 0;
          //   filterParams['page_size'] = 20;
          //   secondApiCallingConditionTrue['query_id'] = "GET_PAGE";
          // }

          this.loader.showSpinner();
          this.sub.add(this.baseService.getData(filterParams, "", secondApiCallingConditionTrue['resource'], secondApiCallingConditionTrue['application'], secondApiCallingConditionTrue['query_id']).subscribe(
            (res) => {
              if (res.erroCode == -1) {
                console.log("Error occured while getting data", res.message);
                this.loader.hideSpinner();
              } else {
                if (res.resource != undefined && res.resource.length > 0) {
                  var items2Bind = secondApiCallingConditionTrue['onResponseFillControls'].split(',');
                  var response = "";
                  if (secondApiCallingConditionTrue.hasOwnProperty('datasource_key')) {
                    response = res['resource']['0'][secondApiCallingConditionTrue.datasource_key];
                  } else {
                    response = res['resource']['0'];
                  }
                  for (let i = 0; i < items2Bind.length; i++) {
                    var key = items2Bind[i];
                    var value = response[key];
                    if (this.controlName.controls) {
                      var singleControl: any = false;
                      if (this.controlName.controls[key] != undefined) {
                        singleControl = this.controlName.controls[key];
                      } else {
                        //handling composite case
                        if (this.setId && this.setId.includes('.')) {
                          if (this.setId.lastIndexOf('.') > - 1) {
                            singleControl = this.controlName.controls[this.setId.substring(0, this.setId.lastIndexOf('.')) + '.' + key];
                          }
                        }
                      }
                      if (singleControl) {
                        singleControl.setValue(value);
                        if (singleControl.question_component != undefined && singleControl.question_component.updateDependentValue != undefined) {
                          singleControl.question_component.updateDependentValue(value);
                        }
                      }

                    }
                  }
                }
              }
              //this.loader.showSpinner();

              this.loader.hideSpinner();
            }, (err) => {
              console.log("Error occured while getting data", err);
              this.loader.hideSpinner();
            }));
        }
        this.focusedIdx = index;
        // this.loader.hideSpinner();
        this.addSelected(item);
      }
    } else {

      this.focusedIdx = undefined;
      this.removeSelected(item);
      if (this._settings.singleSelection && this._data.length == 0) { // this case will in update when we have not yet fired api and shown the data from the view_key
        this._defaultValue = "";
        this.bindData(this.apliCallingRqrPrm);
      }
    }
    try {
      if (event.target.parentElement != undefined) {
        event.target.parentElement.blur()
      }
    } catch (e) {

    }
    if (this._settings.singleSelection && this._settings.closeDropDownOnSelection) {
      this.closeDropdown();
    }
    if (this._settings.createComponent && this._settings.createComponentDatasource && this.selectedItems.length > 0) {
      this.createComponentEvent.emit({
        getterKey: item[this.questions.getterKey],
        data: item.mixdata,
        datasource: this._settings.createComponentDatasource,
        perserveTemplate: this._settings.preserveTemplate,
        keys_to_remove: this.questions.keys_to_remove,
        set_template_block: this.questions.set_template_block
      })
    }
    if (this._settings.createComponent && this._settings.createComponentDatasource && this.selectedItems.length == 0) {
      this.createComponentEvent.emit(false);
    }
    (event != undefined && event) ? event.stopPropagation() : '' ;
  }

  dataForUpdate() {
    //api call to populate data in searchselect for update in opthalmic
    var params = {
      args: "",
      filter: "",
      search: ""
    }
    this.showMoreObj.finalParam = JSON.parse(JSON.stringify(params));
    this.sub.add(this.baseService.getData(params, "", this.apliCallingRqrPrm['resource'], this.apliCallingRqrPrm['application'], this.apliCallingRqrPrm['query_id']).subscribe(
      (res) => {
        this._data = [];
        this.filter.text = "";
        if (res.resource) {
          this.parseMyObject(res.resource);
        }
        this.isLoading = false;
        if (res.errCode != 0)
          this.alerts.error(res.message)
        if (!this.cdr['destroyed']) {
          this.cdr.detectChanges(); //For detecting changes from form and reseting the value
        }
        this.loader.hideSpinner();
      }, (err) => {
        this.isLoading = false;
        if (!this.cdr['destroyed']) {
          this.cdr.detectChanges(); //For detecting changes from form and reseting the value
        }
        console.log("Error occured while getting data", err)
        this.loader.hideSpinner();
      }));
  }

  textToSpeech(key) {
    let popobj = { data: { 'speech': true,'searchElement': true }, size: DialogModalSize.Sm,'title': 'vtotext' };
    this.sub.add(this.dialogService.open(TextToSpeechComponent, popobj).afterClosed.subscribe((result: any) => {
      if (result) {
        let _key = `[data-speech-key="${key}"]`;
        let value_key: any = document.querySelector(_key);
        value_key.value = result;
        value_key.click();
        if(!this._settings.apliCall){
          this.filter.text = result;
          this.onFilterTextChange(result);
          if (!this.cdr['destroyed']) {
            this.cdr.detectChanges(); //For detecting changes from form and reseting the value
          }
        }else{
          this.dataFromApiModel = result;
          this.changeDataBasedModel(result);
        }
      }
    }));
  }

  writeValue(value: any) {
    if (value !== undefined && value !== null && value !== '' && (!Array.isArray(value) || value.length > 0)) {
      clearTimeout(this.resetTimer); // this value replaces whatever the pending reset was queued to clear
    }
    //console.log("value is in write conditin _______", value, this._settings);
    if (value !== undefined && value !== null && ((!this._settings.singleSelection && value.length > 0) || this._settings.singleSelection)) {
      if (this._settings.singleSelection) {
        try {
          this._defaultValue = value;
          /***  This condition is used in case of Populate field dependent */
          if (this._data.length > 0) {
            let item = this._data.find(item => (item.id == value))
            if (item) {
              this.selectedItems = []
              this.setSelectedItem(item)
            }
          } else if (this.controlName == "op-opthalmic-examination") {
            this.dataForUpdate()
            let item = this._data.find(item => (item.id == value))
            if (item) {
              this.selectedItems = []
              this.setSelectedItem(item)
            }
            //to populate data in opthalmic form at update
          }
          /***** Populate field dependent condition end */
          if (this._settings.barcode != undefined && this._settings.barcode) {
            this.setDefaultValueForViewKey();
          }
          if (this._defaultValue == "") {
            this.resetInput('write');
          }
        } catch (e) {
          // console.error(e.body.msg);
        }
      } else {
        try {
          if (typeof value == 'string') {
            value = JSON.parse(value);//fix in case of template
          }
        } catch (error) {
          console.log(error);
        }
        const _data = value.map((item: any) =>
          typeof item === "string" || typeof item === "number"
            ? new ListItem(item)
            : new ListItem({
              id: item[this._settings.idField],
              text: item[this._settings.textField],
              displayName: item[this._settings.displayName],
              itemCode: item[this._settings.itemCode],
              isDisabled: item[this._settings.disabledField],
              coding_system: item.coding_system?item.coding_system:''
            })
        );
        if (this._settings.limitSelection > 0) {
          this.selectedItems = _data.splice(0, this._settings.limitSelection);
        } else {
          const firstItem = _data && _data.length != undefined && _data[0] != undefined ? _data[0] : false;
          if (firstItem) { this._sourceDataType = typeof firstItem; }
          this.selectedItems = _data;
          if (this.questions != undefined && this.questions.defaultsetting != undefined && this.questions.defaultsetting.stopPropagation != undefined && this.questions.defaultsetting.stopPropagation) {
            this._value = this.selectedItems;
          }
        }
      } ``

      this.onChangeCallback(value);
    } else {
      this.resetInput('write');
    }
    //this.bindData(this.);

  }

  resetInput(type?) {
    if(this.utilService.isFireFox()){
      this.setInputData(type);
    }else{
      clearTimeout(this.resetTimer);
      this.resetTimer = setTimeout(() => {
        this.setInputData(type)
      });
    }
  }

  setInputData(type){
    if(this.defaultSettings != undefined && this.defaultSettings['allowedDataAutoFilled'] != undefined && this._settings['allowedDataAutoFilled'] == true){
    }
    else{
      this.selectedItems = [];
    }
    if (type != undefined) {
      this.dataFromApiModel = '';
      if (this.filter && this.filter.text != undefined) {
        this.filter.text = '';
      }
    }
    if (this._settings.singleSelection) {
      this.onChangeCallback("");
    } else {
      this.onChangeCallback([]);
    }
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges(); //For detecting changes from form and reseting the value
    }
  }

  // From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  // From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  // Set touched on blur
  // @HostListener("blur")
  // public onTouched() {
  //   this.ngZone.runOutsideAngular(() => {
  //   this.closeDropdown();
  //   this.onTouchedCallback();
  //   })
  // }

  trackByFn(index, item) {
    return item.id;
  }

  isSelected(clickedItem: ListItem) {
    let found = false;
    this.selectedItems.forEach(item => {
      if (clickedItem.id === item.id) {
        found = true;
      }
    });
    return found;
  }

  isLimitSelectionReached(): boolean {
    return this._settings.limitSelection === this.selectedItems.length;
  }

  isAllItemsSelected(): boolean {
    // get disabld item count
    const itemDisabledCount = this._data.filter(item => item.isDisabled).length;
    // take disabled items into consideration when checking
    return this._data.length === this.selectedItems.length + itemDisabledCount;
  }

  showButton(): boolean {
    if (!this._settings.singleSelection) {
      if (this._settings.limitSelection > 0) {
        return false;
      }
      // this._settings.enableCheckAll = this._settings.limitSelection === -1 ? true : false;
      return true; // !this._settings.singleSelection && this._settings.enableCheckAll && this._data.length > 0;
    } else {
      // should be disabled in single selection mode
      return false;
    }
  }

  itemShowRemaining(): number {
    return this.selectedItems.length - this._settings.itemsShowLimit;
  }

  addSelected(item: ListItem) {
    if (this._settings.singleSelection) {
      this.selectedItems = [];
    }
    this.setSelectedItem(item, true);
  }

  setSelectedItem(item: any, isManual = false) {
    // for checking duplicate item in selectedItems
    if (this.selectedItems != undefined && this.selectedItems && this.selectedItems.length > 0 && this.questions != undefined && this.questions.getterKey != undefined && item[this.questions.getterKey] != undefined){
      let duplicateCheck = this.selectedItems.filter(x=> x['id'] == item['id']);
      if (duplicateCheck && duplicateCheck.length > 0){
        return;
      }
    }
    
    if(this.config && this.config.parentForm && isManual)
      this.config.parentForm._multimanualChange = true;
    if (this._settings.barcode != undefined && this._settings.barcode == true) {
      this.selectedItems = [];
      this.selectedItems.push(item);
    } else {
      this.selectedItems.push(item);
    }
    if (this._settings.singleSelection) {
      this.onChangeCallback(item.id);
    } else {
      this.onChangeCallback(this.emittedValue(this.selectedItems, isManual));
    }
    setTimeout(() => {
      if (this.questions?.defaultsetting?.defaultOpen !== undefined) {
        this._settings.defaultOpen = false;
      }
    });
    this.onSelect.emit(this.emittedValue(item, isManual));
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges(); //For detecting changes from form and reseting the value
    }
  }


  removeSelected(itemSel: ListItem) {
    this.selectedItems.forEach(item => {
      if (itemSel.id === item.id) {
        this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
      }
    });
    setTimeout(() => {
      if (this.questions?.defaultsetting?.defaultOpen !== undefined) {
        this._settings.defaultOpen = true;
      }
    });
    if (this._settings.singleSelection) {
      this.onChangeCallback('');
      this.onDeSelect.emit("");
    } else {
      this.onChangeCallback(this.emittedValue(this.selectedItems));
      this.onDeSelect.emit(this.emittedValue(this.selectedItems));
    }
  }

  emittedValue(val: any, isManual = false): any {
    const selected = [];
    if (Array.isArray(val)) {
      val.map(item => {
        selected.push(this.objectify(item, isManual));
      });
    } else {
      if (val) {
        return this.objectify(val, isManual);
      }
    }
    return selected;
  }

  objectify(val: ListItem, isManual = false) {
    if (this._sourceDataType === 'object') {
      const obj = {};
      obj[this._settings.idField] = val.id;
      obj[this._settings.textField] = val.text;
      if(this._settings.itemCode != undefined && this._settings.itemCode != '')
        obj[this._settings.itemCode] = val.itemCode ? val.itemCode : "";
      if(this._settings.displayName != undefined && this._settings.displayName != '')
        obj[this._settings.displayName] = val.displayName ? val.displayName : "";
      if (!this._settings.enableCheckAll) {
        obj['alldata'] = val.mixdata ? val.mixdata : ""; //done so that we can get the all data if used in other component
      }
      if (this._settings.coding_system != '' || (val['coding_system'] && val['coding_system'] != '')) {
        obj['coding_system'] = val['coding_system'] ? val['coding_system'] : this._settings.coding_system;
      }
      if (this._sourceDataFields.includes(this._settings.disabledField)) {
        obj[this._settings.disabledField] = val.isDisabled;
      }
      // flag reportManualChange added in json to report manual change in case of multiselect
      if (this._settings.singleSelection || this._settings['reportManualChange']) {
        obj["isManual"] = isManual;
      }
      return obj;
    }
    if (this._sourceDataType === 'number') {
      return Number(val.id);
    } else {
      return val.text;
    }
  }

  searchSelectHeight(evt){
    let css = (this.ele && this.ele.nativeElement)? this.ele.nativeElement.getElementsByClassName('dropdown-list-item-container'):'' 
    let heightCalculation = ((window.innerHeight - evt.y) < 380) && ((evt.y - 100) > (window.innerHeight - evt.y))
    let itemSelected = false
    if(this.selectedItems.length > 0){
      itemSelected = true 
    }
    if(css[0] && heightCalculation){
      if(this._settings.singleSelection){
        if(itemSelected){
          css[0].style.maxHeight = ((evt.y) - 240) + 'px'
        }else{
          css[0].style.maxHeight = ((evt.y) - 180) + 'px'
        }
      } else{
        css[0].style.maxHeight = ((evt.y) - 250) + 'px'
      }
      if(((evt.y) - 180) > 245){
        css[0].style.maxHeight = "245px"
      }
      this.greaterHeight = true
    } else if(css[0]){
      if(this._settings.singleSelection){
        if(itemSelected){
          css[0].style.maxHeight = (window.innerHeight - evt.y - 200) + 'px'
        }else {
          css[0].style.maxHeight = (window.innerHeight - evt.y - 150) + 'px'
        }
      } else {
        css[0].style.maxHeight = (window.innerHeight - evt.y - 230) + 'px'
      }
      if((window.innerHeight - evt.y - 180) > 245){
        css[0].style.maxHeight = "245px"
      }
      this.greaterHeight = false
    }
  }
  toggleDropdown(evt) {
    evt.preventDefault();
    if (this.disabled && this._settings.singleSelection) {
      return;
    }
    this.focusedIdx = undefined;
    if (this.selectedItems.length > 0 && this._data.length == 0 && !this._settings['apliCall'] && this.setPre) {
      //if there is selected and apli call is false and no options it means it is update case fire api to get options
      this.bindData(this.apliCallingRqrPrm);
    }
    this._settings.defaultOpen = !this._settings.defaultOpen;
    if(!this.utilService.isMobile()){
      let abc = document.getElementById("aside-modal-container")
      // if(abc && abc.classList && abc.classList.value && !abc.classList.value.includes('d-none')){
      if (abc && abc.classList && abc.classList.value) {
        this.searchSelectHeight(evt)
      }
    }
    if (!this._settings.defaultOpen) {
      this.focusedStatus = false;
      this.onDropDownClose.emit();
    } else {
      //focusing the input search
      try {
        var ele: any = jQuery(evt.target).parent().parent().find(".filter-textbox-input");
        if (ele != undefined && ele[0] != undefined) {
          setTimeout(() => {
            ele[0].focus();
          }, 50)
        }
      } catch (e) {
      }
    }
    this.cdr.detectChanges();
  }

  closeDropdown() {
    this._settings.defaultOpen = false;
    // clear search text
    if (this._settings.clearSearchFilter) {
      this.filter.text = "";
    }
    this.onDropDownClose.emit();
    this.cdr.detectChanges();
  }

  toggleSelectAll() {
    if (this.disabled) {
      return false;
    }
    if (!this.isAllItemsSelected()) {
      // filter out disabled item first before slicing
      this.selectedItems = this._data.filter(item => !item.isDisabled).slice();
      this.onSelectAll.emit(this.emittedValue(this.selectedItems));
    } else {
      this.selectedItems = [];
      this.onDeSelectAll.emit(this.emittedValue(this.selectedItems));
    }
    this.onChangeCallback(this.emittedValue(this.selectedItems));
    this.cdr.detectChanges();
  }
  getItem(item) {
    var res = item.text;
    if (this.data != undefined && this.data.resource != undefined && this.data.resource == "valueset") {
      this.sub.add(this.translateService.translate(res).subscribe(x => {
        if (x) {
          res = x;
        }
      }));
    }
    return res;
  }
  getFields(inputData) {
    const fields = [];
    if (typeof inputData !== "object") {
      return fields;
    }
    // tslint:disable-next-line:forin
    for (const prop in inputData) {
      fields.push(prop);
    }
    return fields;
  }
  noDataFoundSearchAgain(e) {
    this.filter.text = "";
    this.noDataFound();
    this.dataFromApiModel = "";
    this._data;
  }

  addFreeText(text) {
    const emojiRegex = /[\p{Extended_Pictographic}]/gu;
    if (emojiRegex.test(text)) {
      text = text.replace(emojiRegex, '');
      if(this._settings.apliCall){
        this.dataFromApiModel = text;
      }else if(!this._settings.apliCall){
        this.filter.text = text;
      }
      if (text == "" || text == ' ' || text.trim() == '')
        this.alerts.error("f.l.emojiwd");
    }else if (text == "" || text == ' ' || text.trim() == '') {
      this.alerts.error("f.l.entalwd");
    } else if (!this._settings.spclChrFreeTextAllowed && this.baseService.checkForSpecialChar(text)) {
      this.alerts.error("al.sptntallwd");
    } else if (this._settings.spclChrFreeTextAllowed && this._settings.spclChrPattern != "" && this.baseService.checkForSpecialAllowedChar(text, this._settings.spclChrPattern)) {
      this.alerts.error("al.sptntallwd");
    } else {
      let item;
      if (this.defaultSettings.singleSelection) {
        this._sourceDataType = typeof {};
        item = new ListItem(text);
        item.id = text
      } else {
        item = new ListItem({
          id: text,
          text: text
        })
      }
      try {
        item[this.questions.getterKey] = item.id;
        item[this.questions.getterValue] = item.text;
        this.questions['options'].push(item);
      } catch (error) { }
      if (this.defaultSettings.markFreeText) {
        item["isFreeText"] = "true";
      }
      this.onItemClick(item, 0);
      (this._settings.apliCall) ? this.dataFromApiModel = '' : this.filter.text = '';
      this.cdr.detectChanges();
    }
  }

  getConfigForFreeText() {
    if (this._settings['config_key_free_text']) {
      this.sub.add(this.baseService.get("GET_CONFIG", "module_code:emr,config_code:free_text_per_screen", "facility_config_mapping", "facility-management").subscribe(data => {
        if (data.errCode == 0 && data.resource.length > 0) {
          if (data.resource[0].multivalue != undefined && data.resource[0].multivalue != "" && data.resource[0].multivalue.length > 0) {
            let conf_val = data.resource[0].multivalue.find((d) => {
              return d.text == this._settings['config_key_free_text'];
            })
            if (conf_val == undefined)
              this.defaultSettings.configFreeText = false;
            else
              this.defaultSettings.configFreeText = true;
          } else {
            this.defaultSettings.configFreeText = false;
          }
        } else {
          this.defaultSettings.configFreeText = false;
        }
      }));
    } else {
      this.sub.add(this.baseService.get("GET_CONFIG", "module_code:emr,config_code:field_free_text", "facility_config_mapping", "facility-management").subscribe(data => {
        if (data.errCode == 0 && data.resource.length > 0) {
          if (data.resource[0].config_value != undefined && data.resource[0].config_value != "" && data.resource[0].config_value.toLowerCase() == "yes") {
            this.defaultSettings.configFreeText = true;
          } else {
            this.defaultSettings.configFreeText = false;
          }
        } else {
          this.defaultSettings.configFreeText = false;
        }
      }));
    }
  }

  handleKeyEvent(event: Event, up): void {
    event.preventDefault();
    this.focusedStatus = true;
    const avaOpts = this.availableOptions.toArray();
    setTimeout(() => {
      if (up) {
        this.focusedIdx = (this.focusedIdx == undefined) ? -1 : this.focusedIdx;
        this.focusedIdx++;
      } else {
        this.focusedIdx = (this.focusedIdx == undefined) ? 0 : this.focusedIdx;
        if (this.focusedIdx > 0) {
          this.focusedIdx--;
        }
      }
      if (this.focusedIdx < 0) this.focusedIdx = 0;
      if (this.focusedIdx >= avaOpts.length) this.focusedIdx = avaOpts.length - 1;
      if (avaOpts[this.focusedIdx] != undefined) {
        avaOpts[this.focusedIdx].nativeElement.focus();
      }
    });
  }

  changeFocusIndex(index) {
    if (document.activeElement.tagName != "INPUT") {
      if (this.focusedIdx == undefined) {
        return false;
      }
      return this.focusedIdx == index;
    } else {
      return false;
    }
  }

  ngOnDestroy() {
    this.loader.hideSpinner();
    this.sub.unsubscribe();
    if (this._settings && this._settings.onEnterSearch && this.boundEnterHit) {
      window.removeEventListener('keyup', this.boundEnterHit);
    }
    if (this.dataBasedModelChanged.unsubscribe != undefined) {
      this.dataBasedModelChanged.unsubscribe();
    }
    if (this.filterBasedModelChanged.unsubscribe != undefined) {
      this.filterBasedModelChanged.unsubscribe();
    }
  }
  setparentForm() {
    let data = {};
    if (this.config && this.config.parentForm != undefined && this.config.parentForm.value != undefined) {
      var obj = JSON.parse(JSON.stringify(this.config.parentForm.value));
      for (let key in obj) {
        obj["parent__" + key] = obj[key];
        delete obj[key];
      }
      if (this.route.snapshot.params.foreign_id != undefined) {
        obj.foreign_id = this.route.snapshot.params.foreign_id;
      }
      data = { ...obj, ...JSON.parse(sessionStorage.getItem('currentData')), ...this.controlName.value }
      if(this.baseService.authenticationService.getUserType() == "patient"){
        data["uhId"] = this.baseService.getpatientUhid()
      }
      return data // // Merging form data ,localStorage data in a ob ject which will help to prepare filter, 
    } else {
      if (this.controlName)
        data = { ...JSON.parse(sessionStorage.getItem('currentData')), ...this.controlName.value } // // Merging form data ,localStorage data in a ob ject which will help to prepare filter, 
      if (this.route.snapshot.params.foreign_id != undefined) {
        data["foreign_id"] = this.route.snapshot.params.foreign_id;
      }
      if(this.baseService.authenticationService.getUserType() == "patient"){
        data["uhId"] = this.baseService.getpatientUhid()
      }
      return data;
    }
  }
  /*-------------------Get popover details-------------*/
  getDetails() {
    if (this.questions && this.questions.popover) {
      // debugger;
      return this.commonService.getPopOverDetails(this.questions, this._data, this.controlName, this.selectedItems);
      // return this.controlName.controls[this.questions.popover].value ? this.controlName.controls[this.questions.popover].value : null;
    }
  }
  /*********************Get popOver Config**************** */
  getPopOverDetails() {
    if (this.controlName.controls && this.controlName.controls[this.questions.popover] && this.controlName.controls['itemFlag'] && this.controlName.controls['itemFlag'].value && this.controlName.controls['itemFlag'].value.length > 0) {
      return true;
    } else if (this.controlName.controls && this.controlName.controls[this.questions.popover] && this.controlName.controls && this.controlName.controls[this.questions.popover].value) {
      return true;
    } else if (this.selectedItems && this.selectedItems[0] && this.selectedItems[0].mixdata && this.selectedItems[0].mixdata.itemFlag && this.selectedItems[0].mixdata.itemFlag.length > 0) {
      return true;
    }
    return false;
  }
  toggleIcd() {
    this.icd_enable = !this.icd_enable;
    this.prefereceService.saveCommonConfig('icd_enable', this.icd_enable);
  }
  /*-------------------Advance Search works from here-------------*/
  openAdvSearch() {
    let resource = this._settings != undefined && this._settings.advancesearch != undefined && this._settings.advancesearch.resource != undefined ? this._settings.advancesearch.resource : "defaultAdvSearch";
    let datasource_ = this._settings != undefined && this._settings.advancesearch != undefined && this._settings.advancesearch.datasource != undefined && this._settings.advancesearch.datasource ? this._settings.advancesearch.datasource : this.apliCallingRqrPrm;
    let datasource = JSON.parse(JSON.stringify(datasource_));
    let parentForm = this.setparentForm();
    if (datasource_) {
      datasource['args'] = datasource.args != undefined ? this.baseService.buildDyanamicStr(datasource.args, { data: parentForm }) : "";
      datasource['filter'] = datasource.filter != undefined ? this.baseService.buildDyanamicStr(datasource.filter, { data: parentForm }) : "";
      datasource['search_columns'] = datasource.search_columns != undefined ? datasource.search_columns : "";
    }
    let popobj = { data: { 'resource': resource, 'datasource': datasource, question: this.questions }, title: 'Advance Search', size: DialogModalSize.Lg,dropDownSelecteditems : this.selectedItems  };
    let icd_search = this._settings != undefined && this._settings.advancesearch != undefined && this._settings.advancesearch.icd_search != undefined && this._settings.advancesearch.icd_search ? true : false
    if (icd_search && this.icd_enable) {
      let icd_config = localStorage.getItem('icd_config');
      if(icd_config == null){
        this.sub.add(this.baseService.get("GET_CONFIG", "module_code:emr,config_code:icd_no", "facility_config_mapping", "facility-management").subscribe(data => {
          if (data.errCode == 0 && data.resource.length > 0 && data.resource[0].config_value) {
            icd_config = data.resource[0].config_value;
            localStorage.setItem('icd_config', icd_config);
          } else{
            icd_config = '10';
            localStorage.setItem('icd_config', icd_config);
          }
          this.openICDComponent(icd_config, popobj);
        })); 
      }else{
        this.openICDComponent(icd_config, popobj);
      }
    }else{
      this.openAdvanceDialog(popobj);
    }
  }

  openICDComponent(icd_config, popobj){
    let component:any = IcdSearchComponent;
      if(icd_config && icd_config == '10'){
       component = IcdSearchComponent;
      }else if(icd_config && icd_config == '11'){
       component = Icd11Component;
      } 
      
      this.sub.add(this.dialogService.open(component, popobj).afterClosed.subscribe(response => {
        if (response) {
          if (Array.isArray(response)) {
            for (let item of response) {
              this.setMultiselect(item, false);
            }
          }
          else {
            this.setMultiselect(response, false);//for single selection
          }
        }
      }));
  }

  openAdvanceDialog(popobj) {
    this.sub.add(this.dialogService.open(AdvanceSearchComponent, popobj).afterClosed.subscribe(
      response => {
        if (response && this.questions.defaultsetting != undefined) {
          this.setPre = false;
          if (Array.isArray(response)) {
            this.selectedItems = [];
            for (let item of response) {
              console.log("Item ", this.selectedItems, item, this.selectedItems.indexOf(item));
              this.setMultiselect(item,false);
            }
          }
          else {
            this.setMultiselect(response,false);
          }
        }
      }));
  }
  setMultiselect(response,emptyOptions=true) {
    // debugger
    if(emptyOptions){
      this._data = [];
    }
    
    this._sourceDataType = 'object';
    if(response != undefined){
      let cloneRes = JSON.parse(JSON.stringify(response));
      response['mixdata'] = JSON.parse(JSON.stringify(response));
      response['text'] = response[this.questions.getterValue] == undefined ? response['text'] : response[this.questions.getterValue];
      response['id'] = response[this.questions.getterKey] == undefined ? response['id'] : response[this.questions.getterKey];
      if(response['coding_system'] && response['coding_system'] != undefined && response['coding_system'] != ''){
        response['coding_system'] = response['coding_system'];
      }
      this._value = response[this.questions.getterKey] == undefined ? response['id'] : response[this.questions.getterKey];
      if (emptyOptions || !Array.isArray(this.questions['options'])) {
        this.questions['options'] = [];
      }
      let getterKey = this.questions != undefined ? this.questions.getterKey : undefined;
      let alreadyListed = getterKey != undefined && this.questions['options'].some(opt => 
        opt != undefined && opt[getterKey] == cloneRes[getterKey]);
      if (!alreadyListed) {
        this.questions['options'].push(cloneRes);
      }
    }
    if (this.questions != undefined && this.questions.defaultsetting != undefined && this.questions.defaultsetting.createComponent && this.questions.defaultsetting.createComponent == true) {
      response['mixdata'] = JSON.parse(JSON.stringify(response));
      this.onItemClick(response, 0)
    } else{
      if(response != undefined || !this._settings.singleSelection){
        this.addSelected(response);
      }else if(this._settings.singleSelection){
        this.resetInput('write');
      }
    }
      
  }

  changeTextSearch(enabled){
    if(enabled){
      this.questions.origStopSorting = this.questions.stopSorting;
      this.questions.stopSorting = true;
    }else{
      if(this.questions.origStopSorting != undefined){
        this.questions.stopSorting = this.questions.origStopSorting;
      }
    }
  }

  setNoCountArgs(obj){
    if (obj.args != undefined && obj.args.includes("noCount")) {
      //do nothing
    }
    else if (obj.args != undefined && obj.args) {
      obj.args = obj.args + ",noCount:1"
    }
    else {
      obj.args = "noCount:1"
    }
  }
  getFlagText(item?: any) {
    if (item.mixdata) {
      const flags = Array.isArray(item.mixdata.itemFlag) ? item.mixdata.itemFlag : [item.itemFlag];
      if (flags) {
        return flags.map((f: any) => f?.text || f?.id || "").reverse().join(',');
      }
    }
    return "";
  }
}
